let isReferThemeChangeInProgress = false;

export const markReferThemeChangeInProgress = () => {
  isReferThemeChangeInProgress = true;
};

export const consumeReferThemeChangeInProgress = () => {
  const shouldSkipReset = isReferThemeChangeInProgress;
  isReferThemeChangeInProgress = false;

  return shouldSkipReset;
};

export const resetReferThemeChangeInProgress = () => {
  isReferThemeChangeInProgress = false;
};
